"use client";
import  { useEffect, useState } from "react";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.axionnest.com";
export const IndependentResearherProfile = () => {
  const [profile, setProfile] = useState(null);
  // console.log("The profile is:",profile)
  const token = localStorage.getItem("access_token");
  // console.log("The i token is:",token)
  useEffect(() => {

    const fetchProfile = async () => {
      try {
        const res = await fetch(`${BASE_URL}/marketplace/researcher/create-researcher-profile/`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        if (!res.ok) {
          console.error("Failed to fetch profile:", res.status);
          return;
        }

        const data = await res.json();
        setProfile(data?.data || null);
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, []);


  return (
      <>
       {/* <Header/> */}
  <aside className="flex flex-col gap-4 flex-1 w-full">
  {/* Profile Card */}
  <section className="w-full rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-all duration-200 hover:shadow-md hover:border-gray-300">
    {/* Profile Header */}
    <div className="flex items-start gap-4 mb-6">
      <div className="relative">
        <img
          className="
            w-16 h-16
            rounded-xl
            object-cover
            border-2 border-white
            shadow-md
          "
          src={profile?.researcher?.profile_picture || "https://via.placeholder.com/64"}
          alt="Profile"
        />
        <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white"></div>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between">
          <div>
            <h4 className="
              text-lg font-semibold text-gray-900
              truncate
            ">
              {profile?.researcher?.name || "No name provided"}
            </h4>
            
            <div className="flex items-center gap-2 mt-1">
              <span className="
                text-sm font-medium
                px-2.5 py-1
                rounded-lg
                bg-[#e8f0f7]
                text-[#0f6abf]
              ">
                {profile?.researcher?.degree || "Student"}
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-2 truncate">
          {profile?.researcher?.institution || "No institution specified"}
        </p>
      </div>
    </div>

    {/* Primary Affiliation */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Primary Affiliation
        </div>
      </div>
      <div className="text-sm text-gray-900 bg-gray-50 rounded-xl p-3">
        {profile?.researcher?.primary_affiliation || "Not specified"}
      </div>
    </div>

    {/* Current Activity */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Current Activity
        </div>
      </div>
      <div className="text-sm text-gray-900 bg-gray-50 rounded-xl p-3">
        {profile?.researcher?.current_activity || "No current activity"}
      </div>
    </div>
    {/* Research Type */}
 <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Research Type
        </div>
      </div>
      <div className="text-sm text-gray-900 bg-gray-50 rounded-xl p-3">
        {profile?.answers?.research_type ? profile.answers.research_type[0].toUpperCase() + profile.answers.research_type.slice(1) : "Not specified"}

      </div>
    </div>
    {/* Domains */}
    <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Research Domains
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {profile?.researcher?.research_areas ? (
          profile?.researcher.research_areas.split(',').map((domain, index) => (
            <span
              key={index}
              className="
                text-xs font-medium
                px-3 py-1.5
                rounded-lg
                bg-[#e8f0f7]
                text-[#0f6abf]
                hover:bg-[#d0e0f0]
                transition-colors
                truncate
                max-w-full
              "
              title={domain.trim()}
            >
              {domain.trim()}
            </span>
          ))
        ) : (
          <div className="text-sm text-gray-400 italic py-2">
            No research domains specified
          </div>
        )}
      </div>
    </div>
      <div className="border-t border-gray-100 pt-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <div className="text-sm font-semibold text-gray-700">
          Research Interests
        </div>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {profile?.answers?.research_interests ? (
          profile?.answers?.research_interests?.split(',').map((domain, index) => (
            <span
              key={index}
              className="
                text-xs font-medium
                px-3 py-1.5
                rounded-lg
                bg-[#e8f0f7]
                text-[#0f6abf]
                hover:bg-[#d0e0f0]
                transition-colors
                truncate
                max-w-full
              "
              title={domain.trim()}
            >
              {domain.trim()}
            </span>
          ))
        ) : (
          <div className="text-sm text-gray-400 italic py-2">
            No research domains specified
          </div>
        )}
      </div>
    </div>

    {/* Additional Info */}
    {profile?.researcher?.email && (
      <div className="border-t border-gray-100 pt-5">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <div className="text-sm font-semibold text-gray-700">
            Contact
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89-4.26a2 2 0 012.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span className="truncate">{profile?.researcher?.email}</span>
        </div>
      </div>
    )}
  </section>
</aside>
</>
  );
};
